/* Presentation bridge only: Avante owns variants/cart; Uploadly owns uploads/properties. */
(() => {
  if (window.mewoProductPresentation) return;
  window.mewoProductPresentation = true;
  const root = () => document.querySelector('.mewo-pdp');
  function initialize() {
    root()?.querySelectorAll('[data-mewo-fields]:not([data-ready])').forEach(fields => {
      const custom = fields.closest('custom-options');
      const canonical = custom.querySelector('textarea[name^="properties["]');
      if (!canonical || canonical.value.trim()) return; // Never lose an existing customer draft.
      fields.dataset.ready = 'true'; fields.hidden = false;
      custom.classList.add('mewo-fields-enhanced');
      fields.querySelectorAll('[data-mewo-field]').forEach(input => { input.required = input.dataset.mewoRequired === 'true'; });
    });
    syncSelection();
  }
  function syncFields(fields) {
    const canonical = fields.closest('custom-options').querySelector('textarea[name^="properties["]');
    canonical.value = [...fields.querySelectorAll('[data-mewo-field]')].filter(i => i.value.trim()).map(i => `${i.dataset.mewoField}: ${i.value.trim()}`).join('\n');
    canonical.dispatchEvent(new Event('input', {bubbles:true}));
    fields.querySelector('[role="alert"]').hidden = true;
  }
  function syncSelection() {
    const section = root(); if (!section) return;
    const price = section.querySelector('[data-mewo-selected-price]');
    const mobilePrice = section.querySelector('[data-mewo-mobile-price]');
    if (price && mobilePrice && mobilePrice.textContent !== price.dataset.mewoSelectedPrice) mobilePrice.textContent = price.dataset.mewoSelectedPrice;
    // Uploadly's missing-file control clones the purchase button once. Refresh only
    // its displayed price after native variant updates; preserve its node/listeners.
    const clonePrice=section.querySelector('[data-ph-cart-clone] .price-inside-button');
    if(price && clonePrice && clonePrice.textContent !== price.dataset.mewoSelectedPrice) clonePrice.textContent=price.dataset.mewoSelectedPrice;
    const mobileVariant = section.querySelector('[data-mewo-mobile-variant]');
    const options = [...section.querySelectorAll('variant-selects select')].map(s=>s.value).join(' · ');
    if (mobileVariant && options && mobileVariant.textContent !== options) mobileVariant.textContent = options;
  }
  document.addEventListener('input',event => { if(event.target.matches('[data-mewo-field]')) syncFields(event.target.closest('[data-mewo-fields]')); });
  document.addEventListener('click',event => {
    if(event.target.closest('[data-mewo-personalize]')){
      const section=root(); const target=[...section.querySelectorAll('.mewo-uploadly-open,.uploadcare--widget__button_type_open,.mewo-uploadly-change,[data-mewo-fields]:not([hidden]) input,custom-options textarea,.product-form__submit')].find(node=>node.getClientRects().length && !node.disabled);
      if(target){target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});target.focus({preventScroll:true});}
    }
  });
  // Capture before native cart handlers; never issue a separate cart request.
  document.addEventListener('submit',event => {
    const form=event.target;
    if(!form.matches('product-form form') || !form.closest('.mewo-pdp'))return;
    for(const fields of root().querySelectorAll('[data-mewo-fields][data-ready]')){
      syncFields(fields);
      const invalid=[...fields.querySelectorAll('[data-mewo-field]')].find(i=>!i.checkValidity());
      if(invalid){event.preventDefault();event.stopImmediatePropagation();fields.querySelector('[role="alert"]').hidden=false;invalid.focus();invalid.reportValidity();return;}
    }
  },true);
  let pending=false;
  const observer=new MutationObserver(()=>{if(!pending){pending=true;requestAnimationFrame(()=>{pending=false;initialize();});}});
  if(root())observer.observe(root(),{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',()=>{initialize();if(root())observer.observe(root(),{childList:true,subtree:true});});
  document.addEventListener('change',event=>{if(event.target.closest('variant-selects'))syncSelection();});
  initialize();
})();

if (!window.mewoProductExtrasBound) {
window.mewoProductExtrasBound = true;
// Dismiss tips without making the visitor find the summary again.
// Capture any tap away from the toggle, including the panel over mobile fields.
document.addEventListener('click',event=>{document.querySelectorAll('.mewo-photo-tips[open]').forEach(tips=>{if(!tips.querySelector('summary')?.contains(event.target))tips.open=false;});},true);
document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;document.querySelectorAll('.mewo-photo-tips[open]').forEach(tips=>{tips.open=false;tips.querySelector('summary')?.focus();});});

// Shopify supplies relevant recommendations; this only pages through their cards.
function initializeMewoRelated(){
 document.querySelectorAll('[data-mewo-related]:not([data-ready])').forEach(root=>{
  root.dataset.ready='true';const track=root.querySelector('.mewo-related-track');
  const controls=root.querySelector('.mewo-related-controls'),buttons=[...controls.querySelectorAll('button')],status=root.querySelector('[data-related-status]');
  const update=()=>{const cards=[...track.children],width=track.clientWidth,max=track.scrollWidth-width;
   controls.hidden=max<2;buttons[0].disabled=track.scrollLeft<2;buttons[1].disabled=track.scrollLeft>=max-2;
   const box=track.getBoundingClientRect();const visible=cards.map((card,i)=>({i,r:card.getBoundingClientRect()})).filter(x=>x.r.left>=box.left-2&&x.r.left<box.right-2);
   if(visible.length)status.textContent=`Designs ${visible[0].i+1}–${visible[visible.length-1].i+1} of ${cards.length}`;
  };
  buttons.forEach(button=>button.addEventListener('click',()=>{const card=track.firstElementChild;const gap=parseFloat(getComputedStyle(track).columnGap)||0,step=card.getBoundingClientRect().width+gap,visible=Math.max(1,Math.round(track.clientWidth/step));track.scrollBy({left:step*visible*Number(button.dataset.relatedDirection),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}));
  track.addEventListener('scroll',update,{passive:true});const observer=new ResizeObserver(update);observer.observe(track);root.mewoRelatedCleanup=()=>observer.disconnect();update();
 });
}
document.addEventListener('product-recommendations:load',initializeMewoRelated);
document.addEventListener('shopify:section:load',initializeMewoRelated);
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-mewo-related]').forEach(root=>root.mewoRelatedCleanup?.()));
initializeMewoRelated();

}
